import { inject } from '@core/di/di-utils';

import { DI_TOKENS } from '@shared/constants/di';
import { ICommentsService } from '@shared/types/services/comments';

export class ThreadViewModel {
  private commentsService = inject<ICommentsService>(DI_TOKENS.commentsService);

  getList: ICommentsService['getList'] = (...args) => {
    return this.commentsService.getList(...args);
  };
}
